export interface PitMap {
  size: Vector2;

  pits: {[address: string]: Pit};
  walls?: {[id: string]: Wall};
  areas?: {[id: string]: Area};
  arrows?: {[id: string]: Arrow};
  labels?: {[id: string]: Label};
}

export interface Positionable {
  position: Vector2;
  size: Vector2;
  angle?: number;
}

export interface Pit extends Positionable {
}

export interface Wall extends Positionable {
}

export interface Area extends Positionable {
  label: string;
}

export interface Label extends Positionable {
  label: string;
}

export interface Arrow extends Positionable {
  type: 'single'|'double';
  color?: 'red'|'blue'|'gray'|'purple';
}

export interface Vector2 {
  x: number;
  y: number;
}

export const defaultPitMap: PitMap = {size: {x: 1200, y: 1500}, pits: {}};

export interface PitMapLibrary {
  [eventKey: string]: PitMapLibraryEntry;
}

export interface PitMapLibraryEntry {
  name: string;
  pitCount: number;
}
